import React from "react";

interface NoCandidatesFoundProps {
  parsedContent: any;
}

export default function NoCandidatesFoundAgent({
  parsedContent,
}: NoCandidatesFoundProps): JSX.Element {
  return (
    <div style={{ textAlign: "center" }}>
      <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
        No candidates found. Please change your criteria using the qualification
        filters below.{" "}
      </p>
    </div>
  );
}
